// extracted by mini-css-extract-plugin
export default {"container":"OC-z","dimension":"PC-z","dimensionLabels":"QC-z"};